import React, { useMemo } from "react";
import { useState } from "react";
import { Grid, Icon, Divider } from "@mui/material";
import ModalRoot from "containers/modal/ModalRoot";
import SuiBox from "components/SuiBox";
import ModalHeader from "containers/modal-header";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import CustomButton from "containers/CustomButton";
import ImageUpload from "components/ChooseImage/image";
import { toast } from "react-toastify";

export default function ScheduleModal({
  open,
  onSave,
  mode,
  editHandler,
  viewHandler,
  onClose,
  selectedItem,
  doesScheduleTimeExist,
}) {
  const defaultHandler = useMemo(() => {
    return {
      title: "",
      time: "",
      icon: null,
    };
  }, []);

  //error handler
  const errorDefault = useMemo(() => {
    return {
      title: false,
      time: false,
      icon: false,
    };
  }, []);

  const [formData, setFormData] = useState(defaultHandler);
  const [errorMessage, setErrorMessage] = useState(errorDefault);
  const [loader, setLoader] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      toast.error("Title is required");
      return;
    }
    if (!formData.time.trim()) {
      toast.error("Time is required");
      return;
    }
    if (doesScheduleTimeExist(formData.time)) {
      toast.error("This time already exists in the schedule");
      return;
    }
    onSave(formData);
    setFormData({ title: "", time: "", icon: null });
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setFormData((prev) => ({ ...prev, icon: file }));
    }
  };

  const handleDeleteImage = () => {
    setFormData({ ...formData, icon: null });
  };
  return (
    <ModalRoot
      variant="permanent"
      ownerState={{ openConfigurator: open }}
      width="60%"
    >
      <SuiBox
        style={{ whiteSpace: "normal !important" }}
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={3}
        pb={0.8}
        px={3}
      >
        <ModalHeader mode={mode} title="custom schedule" />

        <Grid item>
          {mode === "view" && (
            <Icon
              sx={({
                typography: { size, fontWeightBold },
                palette: { dark },
              }) => ({
                fontSize: `${size.md} !important`,
                fontWeight: `${fontWeightBold} !important`,
                stroke: dark.main,
                strokeWidth: "2px",
                cursor: "pointer",
                mt: 2,
                mr: 2,
              })}
              onClick={() => {
                editHandler(selectedItem, "payment");
              }}
            >
              edit
            </Icon>
          )}
          {mode === "edit" && (
            <Icon
              sx={({
                typography: { size, fontWeightBold },
                palette: { dark },
              }) => ({
                fontSize: `${size.md} !important`,
                fontWeight: `${fontWeightBold} !important`,
                stroke: dark.main,
                strokeWidth: "2px",
                cursor: "pointer",
                mt: 2,
                mr: 2,
              })}
              onClick={() => viewHandler(selectedItem, "payment")}
            >
              visibility
            </Icon>
          )}
          <Icon
            sx={({
              typography: { size, fontWeightBold },
              palette: { dark },
            }) => ({
              fontSize: `${size.md} !important`,
              fontWeight: `${fontWeightBold} !important`,
              stroke: dark.main,
              strokeWidth: "2px",
              cursor: "pointer",
              mt: 2,
            })}
            onClick={onClose}
          >
            close
          </Icon>
        </Grid>
      </SuiBox>

      <Divider />

      <SuiBox pt={3} pb={0.8} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Title
              </SuiTypography>
              <SuiInput
                disabled={mode === "view"}
                type="text"
                name="title"
                readOnly={mode === "view"}
                error={errorMessage?.title}
                value={formData.title ?? ""}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    [e.target.name]: e.target.value,
                  });

                  setErrorMessage({
                    ...errorMessage,
                    [e.target.name]: false,
                  });
                }}
              />
            </SuiBox>
          </Grid>

          {/* Time */}

          <Grid item xs={12} lg={6}>
            <SuiTypography mb={1} variant="h6">
              Time
            </SuiTypography>
            <SuiInput
              disabled={mode === "view"}
              type="time"
              name="time"
              readOnly={mode === "view"}
              value={formData.time}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, time: e.target.value }))
              }
            />
          </Grid>

          {/* Upload Icon */}
          <Grid item xs={12} lg={12}>
            <ImageUpload
              id="schedule_icon"
              variant="dashed"
              image={formData.icon}
              onChange={handleFileChange}
              onDelete={handleDeleteImage}
              label="Upload Icon"
              avatarLabel="Upload ⬆"
              previewHeight={120}
              width={250}
            />
          </Grid>

          {mode !== "view" && (
            <Grid item xs={12}>
              <CustomButton
                color="dark"
                variant="gradient"
                onClick={handleSubmit}
                fullWidth
                disabled={loader || !open}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                title={"Save schedule"}
                loader={loader}
              />
            </Grid>
          )}
        </Grid>
      </SuiBox>
    </ModalRoot>
  );
}
